import {createAction} from 'redux-actions';
import {setScrollDirection, scrollTo} from './view';

import {
  SET_CURRENT_PRODUCT,
} from '../config/const';
import { setActiveCategoryIndex } from './api';
import { FETCH_PRODUCTS_COMPLETE, SEARCH_PRODUCTS } from '../reducers/productReducer';
export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const setProduct = createAction(SET_CURRENT_PRODUCT, product => product);
export const SET_CATEGORY = 'SET_CATEGORY';

export function fetchProductsComplete() {
  return dispatch => {
    dispatch({
      type: FETCH_PRODUCTS_COMPLETE,
    });
  };
}


export function fetchProducts() {
  return dispatch => {
    dispatch({
      type: FETCH_PRODUCTS
    });
  };
}

export function searchProducts() {
  return dispatch => {
    dispatch({
      type: SEARCH_PRODUCTS
    });
  };
}

export function showProduct(index) {
  return dispatch => {
    dispatch(setInfiniteScroll(false));
    dispatch(setViewDetail(index, true));
    dispatch(setScrollDirection('up'));
  };
}
export function showCart(index) {
  return dispatch => {
    dispatch(setCartDetail(true));
  };
}
export function hideCart(index) {
  return dispatch => {
    dispatch(setCartDetail(false));
  };
}
export const setCurrentCategoryIndex = (index) => ({
  type: SET_CATEGORY,
  payload: index
});
// todo: move to view reducerr
export const setInfiniteScroll = (state) => ({
  type: 'SET_INFINITE_SCROLL',
  payload: state
});
export const setProductFetching = (state) => ({
  type: 'SET_PRODUCT_FETCHING',
  payload: state
});

/* when user unselect a category on the CategoryBar, we reset scroll view to default state  */
export const reset = (state) => dispatch => {
  dispatch(setProductFetching(false));
  dispatch(setCurrentCategoryIndex(-1));
  dispatch(setInfiniteScroll(true));
  dispatch(cleanProductsData());
  dispatch(setActiveCategoryIndex(-1));
  dispatch(scrollTo(0));
  dispatch({
    type: 'RESET_PRODUCTS',
    payload: state
  });
};

export const resetSearch = (state) => dispatch => {
  dispatch(setProductFetching(false));
  dispatch(setCurrentCategoryIndex(-1));
  dispatch(setInfiniteScroll(true));
  dispatch(cleanProductsData());
  dispatch(setActiveCategoryIndex(-1));
  dispatch({
    type: 'RESET_SEARCH',
    payload: state
  });
};

export const resetCurrentCategory = (state) => dispatch => {
  dispatch(setProductFetching(false));
  dispatch(setInfiniteScroll(false));
  dispatch(cleanProductsData());
  dispatch({
    type: 'RESET_CURRENT_CATEGORY',
    payload: state
  });
};

export const cleanProductsData = (state) => ({
  type: 'CLEAN_PRODUCTS_DATA',
  payload: state
});

function setViewDetail(id, isOpen) {
  return {type: 'SHOW_DETAIL_VIEW', payload: {viewName: 'PRODUCT_DETAIL', id, isOpen}};
}
function setCartDetail(isOpen) {
  return {type: 'SHOW_DETAIL_VIEW', payload: {viewName: 'CART_DETAIL', isOpen}};
}

export const hideViewDetail = () => (dispatch, getState) => {
  dispatch({type: 'HIDE_DETAIL_VIEW'});
  if (getState().view.pos > 0) {
    dispatch({
      type: 'RESET_SCROLL_TOP',
      payload: getState().view.pos
    });
  }
  dispatch(setInfiniteScroll(true));
};



// WEBPACK FOOTER //
// ./src/actions/product.js